<img src="assets/grupo-madero-logo.svg" alt="Logo Grupo Madero" width="300" height="150" />

@if (codeError()) {
<div class="fade-in-left text-center">
  <p>
    Opss! Tivemos um probleminha
    <br />
    Leia o QR Code novamente para entrar na fila.
  </p>
</div>
} @else {
<div class="fade-in-left text-center">
  <mat-spinner color="primary" diameter="50"></mat-spinner>
  <p>Aguarde enquanto você é redirecionado para a fila de espera...</p>
</div>
}
